/*
 * ygh-stock-schedule.js - the Nordwood buy-now availability cycle (2026-09-24).
 *
 * The cycle is defined ONCE in theme settings (Nordwood availability cycle > schedule JSON) and
 * injected by layout/theme.liquid as window.YGH_STOCK_SCHEDULE:
 *   { "start": "2026-09-23", "drop": "00:00",
 *     "phases": [ { "days": 3, "from": 30, "to": 20, "pct": 35 },
 *                 { "days": 4, "from": 20, "to": 10, "pct": 30 },
 *                 { "days": 4, "from": 10, "to": 0,  "pct": 25 },
 *                 { "days": 3, "from": 0,  "to": 0,  "pct": 0, "soldout": true } ],
 *     "repeat": true }
 *
 * Day 0 starts at `drop` (US Eastern) on `start`. Inside a phase the unit count walks from `from`
 * towards `to`, one step per calendar day (rounded), so 30 -> 27 -> 23 and the next phase opens at 20.
 * `soldout` phases mark buy-now as sold out. After the last phase the cycle repeats when `repeat` is true.
 * The PRICES are not changed here: Rai sets the phase prices in Shopify. This script only drives copy.
 *
 * What it does on every page:
 *   - window.yghStock = { units, pct, phase (1-based), day (0-based inside the phase), soldOut,
 *                         nextPct, nextUnits, nextDrop (Date), cycleDay }
 *   - replaces the tokens [units] [pct] [next-pct] [next-units] in the text of the copy elements listed
 *     in SELECTORS (sale banners, announcement bar, cart notice, PDP band, stock tags, drawer stock line)
 *   - adds html.ygh-stock-soldout while buy-now is sold out and fires "ygh:stock" on document
 *   - QA: ?ygh-day=N (days since start) or ?ygh-phase=N previews another point of the cycle
 * The daily countdowns next to this copy use data-end="nightly 00:00-00:01" (ygh-countdown.js), which
 * resets at the same midnight-ET moment the units drop.
 *
 * Prices are changed by the ygh-nord-phase worker (raitislo.com/YGH/nord-phase). This script fetches its
 * public /state: the worker's schedule replaces the theme copy (one place to edit), and while the worker has
 * not yet CONFIRMED the prices of the phase the clock says, the [pct] shown is the tier that is really live
 * (appliedTier), so the copy never promises a discount the checkout does not give. html.ygh-stock-pending is
 * set by theme.liquid and cleared here after the first pass (the side cart hides its tokened heading until then).
 *
 * Limited drop (2026-10-01, "8 greenhouses at 45% off"): the ygh-events worker serves REAL counts at /YGH/events/drop
 * {active, total, sold, left, viewers, carts_24h}: units sold come from Shopify orders, viewers from sessions active on the
 * product page in the last 5 minutes, carts from Order now taps in 24 h. While a drop is active:
 *   [units] = units left, floored at UNITS_FLOOR (2): the copy never reads 1 or 0, and the line is always
 *   shown even with no drop data. [total] = size of the drop, [sold], [viewers], [carts]
 *   [data-ygh-pips] gets one marker per unit (sold ones dimmed), [data-ygh-live="viewers|carts"] lines show only when their
 *   number reaches data-min. The drop copy is never hidden by a low count (hard rule, Kris 2026-10-02).
 */
(function () {
  if (window.__yghStockSchedule) return;
  window.__yghStockSchedule = true;
  var S = window.YGH_STOCK_SCHEDULE;
  if (!S || !S.phases || !S.phases.length || !S.start) return;
  // The shown count never drops below this. Real orders keep being counted, this only floors what the
  // copy says, so the band cannot read '1 left' or '0 left' (Kris, 2026-10-02).
  var UNITS_FLOOR = 2;
  function floorUnits(n) { n = parseInt(n, 10); if (isNaN(n)) return n; return n < UNITS_FLOOR ? UNITS_FLOOR : n; }
  var STATE_URL = 'https://raitislo.com/YGH/nord-phase/state';
  var DROP_URL = 'https://raitislo.com/YGH/events/drop';
  var D = null; // last drop state
  try { var dc = JSON.parse(localStorage.getItem('ygh_drop') || 'null'); if (dc && dc.ts && Date.now() - dc.ts < 30 * 60 * 1000) D = dc.state; } catch (e) {}
  // The units line waits for the real counts (cached, or the first answer of the worker, 4 s at most) before its first
  // render: drawn earlier it showed the floor number first and then jumped to the real one without the count-down.
  var D_READY = !!D;
  var W = null; // last known worker state { schedule, appliedTier, confirmed, ... }
  var W_TS = 0; // when W was fetched on THIS page (0 = came from localStorage: schedule only, never the tier override)
  function useWorker(o) {
    if (!o || typeof o !== 'object') return;
    if (o.schedule && o.schedule.phases && o.schedule.phases.length && o.schedule.start) S = o.schedule;
    W = o;
  }
  // 2026-09-26: the cached copy seeds the SCHEDULE only. Its appliedTier is yesterday's after a phase boundary (a browser that
  // visited on day 3 showed "20 units at 35%" on day 4 while the bar said 30%), so the tier override needs a fresh fetch.
  try { var c = JSON.parse(localStorage.getItem('ygh_nord_phase') || 'null'); if (c && c.ts && Date.now() - c.ts < 6 * 3600 * 1000) { useWorker(c.state); W_TS = 0; } } catch (e) {}

  var SELECTORS = '.nh-sale__heading, .nh-sale__subtext, .announcement-bar, .ygh-cart__sale-name, .ygh-cart__sale-sub, .promo-title, .promo-offer, .fo-stock, .shd-stock, .ua-tip__text, .nwps__title, .nwps__text, .nwps__sub, .nwps__outro, .nnvh__h1, .nnvh__sub, .price-eyebrow, [data-ygh-stock-text], .promo-live';

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  // Wall-clock ET -> UTC ms (same approach as ygh-countdown.js, DST-aware via Intl).
  function etToUtc(ymd, hm) {
    var iso = ymd + 'T' + hm + ':00';
    var guess = Date.parse(iso + 'Z');
    try {
      var f = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      for (var i = 0; i < 2; i++) {
        var p = {}; f.formatToParts(new Date(guess)).forEach(function (x) { p[x.type] = x.value; });
        var asIf = Date.parse(p.year + '-' + p.month + '-' + p.day + 'T' + p.hour + ':' + p.minute + ':' + p.second + 'Z');
        guess += Date.parse(iso + 'Z') - asIf;
      }
      return guess;
    } catch (e) { return guess + 5 * 3600 * 1000; }
  }
  function addDays(ymd, n) { var d = new Date(ymd + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); }

  function compute(now) {
    var drop = /^\d{1,2}:\d{2}$/.test(S.drop || '') ? S.drop : '00:00';
    var total = S.phases.reduce(function (t, p) { return t + (+p.days || 0); }, 0);
    var q = {}; try { location.search.replace(/[?&]([^=&]+)=([^&]*)/g, function (_, k, v) { q[k] = decodeURIComponent(v); }); } catch (e) {}
    var qa = q['ygh-day'] != null || !!q['ygh-phase'];
    var cycleDay, i, acc = 0;
    if (q['ygh-day'] != null) cycleDay = Math.max(0, parseInt(q['ygh-day'], 10) || 0);
    else {
      var t0 = etToUtc(S.start, drop);
      cycleDay = Math.floor((now - t0) / 86400000);
      if (cycleDay < 0) cycleDay = 0;
    }
    if (q['ygh-phase']) { var ph = Math.max(1, Math.min(S.phases.length, parseInt(q['ygh-phase'], 10) || 1)); acc = 0; for (i = 0; i < ph - 1; i++) acc += +S.phases[i].days; cycleDay = acc; }
    var d = S.repeat === false ? Math.min(cycleDay, total - 1) : (total ? cycleDay % total : 0);
    var cycles = total ? Math.floor(cycleDay / total) : 0;
    acc = 0;
    for (i = 0; i < S.phases.length; i++) {
      var p = S.phases[i], days = +p.days || 1;
      if (d < acc + days || i === S.phases.length - 1) {
        var day = Math.max(0, Math.min(days - 1, d - acc));
        var from = +p.from || 0, to = +p.to || 0;
        var units = Math.round(from - (from - to) * day / days);
        var next = S.phases[(i + 1) % S.phases.length];
        var nextDropDay = (S.repeat === false && cycleDay >= total - 1) ? null : cycles * total + acc + day + 1;
        var st = { units: units, pct: +p.pct || 0, phase: i + 1, day: day, soldOut: !!p.soldout, nextPct: +next.pct || 0, nextUnits: +next.from || 0, phaseDays: days, cycleDay: cycleDay, nextDrop: nextDropDay == null ? null : new Date(etToUtc(addDays(S.start, nextDropDay), drop)), title: p.title || '', line: p.line || '' };
        // the tier the checkout really charges: while the worker has not confirmed this phase's prices, show the applied one
        var tier = st.soldOut ? 25 : st.pct;
        if (!qa && W && W_TS && Date.now() - W_TS < 15 * 60 * 1000 && typeof W.appliedTier === 'number' && W.appliedTier !== tier && !st.soldOut) { st.pct = W.appliedTier; st.priceLag = true; }
        return st;
      }
      acc += days;
    }
  }

  // "Only N in stock at this price": the first time it is on screen the number steps down from the size of the drop to what is
  // really left and the bar settles at left/total; afterwards it only moves when a real order changes the count.
  function renderUnits(el, drop) {
    // data-ygh-units="<product handle>": another product of the sale with its own allocation (drop.pools, real orders of that
    // product). No handle, or the handle of the main drop = the main count. A handle without a pool shows nothing.
    var ph = el.getAttribute('data-ygh-units');
    if (drop && ph && ph !== drop.handle) drop = drop.pools && drop.pools[ph] ? drop.pools[ph] : null;
    // Always on, never under UNITS_FLOOR. No drop data still shows the floor instead of hiding.
    var fallback = !drop;
    if (!drop) drop = { left: UNITS_FLOOR, total: UNITS_FLOOR };
    // real counts arriving after a fallback render (slow or failed first request) start over: count down from the drop size
    if (el.__yghFallback && !fallback) el.__yghLeft = undefined;
    el.__yghFallback = fallback;
    el.hidden = false;
    var num = el.querySelector('[data-ygh-units-num]'), fill = el.querySelector('[data-ygh-units-fill]');
    if (!fill && el.closest) { var card = el.closest('.yfb, .nh-sale__card'); if (card) fill = card.querySelector('[data-ygh-units-fill]'); } // banner: bar on the card edge
    if (!num) return;
    var target = floorUnits(drop.left), total = drop.total || target;
    if (total < target) total = target;
    if (el.__yghLeft === target) return;
    var first = el.__yghLeft === undefined;
    el.__yghLeft = target;
    // one animation per element: a newer render (real counts after the fallback, a new order) cancels the one before it
    var token = el.__yghTok = (el.__yghTok || 0) + 1;
    if (el.__yghIo) { try { el.__yghIo.disconnect(); } catch (e) {} el.__yghIo = null; }
    function set(n, tick) {
      num.textContent = String(n);
      if (tick) { num.classList.remove('is-tick'); void num.offsetWidth; num.classList.add('is-tick'); }
      // The bar is a low-stock gauge, not a "share of the drop": a full bar would be a normal batch, and a drop of this size is
      // about 30% of one, so a fresh drop reads 30% and it shrinks from there with every unit sold (Rai + Kris 2026-10-01).
      if (fill) fill.style.width = Math.max(2, Math.round(n / total * 30)) + '%';
    }
    function run() {
      if (el.__yghTok !== token) return;
      var from = first ? total : parseInt(num.textContent, 10) || total;
      if (from <= target) { set(target, true); return; }   // nothing sold yet: the bar fills to 100% and the number ticks once
      var n = from; set(n, false);
      (function step() { if (n <= target) return; n--; setTimeout(function () { if (el.__yghTok !== token) return; set(n, true); step(); }, 260); })();   // 0.26 s a unit (was 0.42 s)
    }
    if (first && 'IntersectionObserver' in window) {
      num.textContent = String(total); if (fill) fill.style.width = '0%';   // the bar always fills in from empty when it is first seen
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); setTimeout(run, 200); } }, { threshold: 0.6 });
      el.__yghIo = io; io.observe(el);
    } else run();
  }

  var TPL = typeof WeakMap === 'function' ? new WeakMap() : { get: function () {}, set: function () {} };
  function apply() {
    var st = compute(Date.now());
    if (!st) return;
    window.yghStock = st;
    document.documentElement.classList.toggle('ygh-stock-soldout', st.soldOut);
    if (st.soldOut && !document.getElementById('ygh-stock-soldout-css')) { // the buy-now offer copy has nothing to say while sold out
      var css = document.createElement('style'); css.id = 'ygh-stock-soldout-css';
      css.textContent = '.ygh-stock-soldout .nh-sale, .ygh-stock-soldout .announcement-bar--sale, .ygh-stock-soldout #mini-cart .ygh-cart__sale { display: none !important; }';
      document.head.appendChild(css);
    }
    var map = { '[units]': String(floorUnits(st.units)), '[pct]': String(st.pct), '[next-pct]': String(st.nextPct), '[next-units]': String(st.nextUnits) };
    var drop = D && D.active ? D : null;
    document.documentElement.classList.toggle('ygh-drop-on', !!drop);
    // Hard rule (Kris, 2026-10-02): the drop copy stays up whatever the real count says.
    document.documentElement.classList.toggle('ygh-drop-soldout', false);
    if (drop) { map['[units]'] = String(floorUnits(drop.left)); map['[total]'] = String(drop.total); map['[sold]'] = String(drop.sold); map['[viewers]'] = String(drop.viewers || 0); map['[carts]'] = String(drop.carts_24h || 0); st.drop = drop; }
    var pips = document.querySelectorAll('[data-ygh-pips]');
    for (var pi = 0; pi < pips.length; pi++) {
      var host = pips[pi];
      if (!drop) { host.hidden = true; continue; }
      var sig = drop.total + ':' + drop.left;
      if (host.getAttribute('data-sig') !== sig) {
        var html = '';
        for (var u = 0; u < drop.total; u++) html += '<span class="promo-pip' + (u < drop.sold ? ' is-sold' : '') + '"></span>';
        host.innerHTML = html; host.setAttribute('data-sig', sig); host.setAttribute('aria-label', drop.left + ' of ' + drop.total + ' left');
      }
      host.hidden = false;
    }
    var uni = document.querySelectorAll('[data-ygh-units]');
    if (D_READY) for (var ui = 0; ui < uni.length; ui++) renderUnits(uni[ui], drop);
    var lives = document.querySelectorAll('[data-ygh-live]');
    for (var li = 0; li < lives.length; li++) {
      var n = drop ? (lives[li].getAttribute('data-ygh-live') === 'carts' ? drop.carts_24h : drop.viewers) : 0;
      lives[li].hidden = !(n >= (parseInt(lives[li].getAttribute('data-min'), 10) || 3));
    }
    var els = document.querySelectorAll(SELECTORS);
    for (var i = 0; i < els.length; i++) {
      var map2 = map, vx = els[i].closest ? els[i].closest('[data-ygh-stock-vars]') : null; // hero-scoped tokens: [price] [base] (selected variant)
      if (vx) { try { map2 = {}; for (var k0 in map) map2[k0] = map[k0]; var ex = JSON.parse(vx.getAttribute('data-ygh-stock-vars') || '{}'); for (var k1 in ex) map2[k1] = String(ex[k1]); } catch (e) { map2 = map; } }
      var w = document.createTreeWalker(els[i], NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        // each text node keeps its original tokened text, so a later pass (worker state arrived, day rolled over
        // while the tab stayed open) re-renders it instead of being stuck with the first numbers
        var tpl = TPL.get(n);
        if (tpl === undefined) { if (n.nodeValue.indexOf('[') < 0) continue; tpl = n.nodeValue; TPL.set(n, tpl); }
        var v = tpl;
        for (var k in map2) v = v.split(k).join(map2[k]);
        if (v !== n.nodeValue) n.nodeValue = v;
      }
    }
    try { document.dispatchEvent(new CustomEvent('ygh:stock', { detail: st })); } catch (e) {}
    document.documentElement.classList.remove('ygh-stock-pending');
  }
  apply();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  function refresh() { // fresh worker state (60 s edge cache): schedule + the confirmed tier
    try {
      fetch(STATE_URL, { mode: 'cors', credentials: 'omit', cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (o) {
        if (!o) return;
        useWorker(o); W_TS = Date.now(); apply();
        try { localStorage.setItem('ygh_nord_phase', JSON.stringify({ state: o, ts: Date.now() })); } catch (e) {}
      }).catch(function () {});
    } catch (e) {}
  }
  refresh();
  function refreshDrop() { // real counts, 30 s edge cache
    try {
      fetch(DROP_URL, { mode: 'cors', credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (o) {
        if (!o) { D_READY = true; apply(); return; }
        D = o; D_READY = true; apply();
        try { localStorage.setItem('ygh_drop', JSON.stringify({ state: o, ts: Date.now() })); } catch (e) {}
      }).catch(function () { D_READY = true; apply(); });
    } catch (e) { D_READY = true; }
  }
  refreshDrop();
  setTimeout(function () { if (!D_READY) { D_READY = true; apply(); } }, 4000);
  setInterval(refreshDrop, 60 * 1000);
  setInterval(refresh, 5 * 60 * 1000); // a tab left open across midnight ET picks up the new tier
  try { document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); }); window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); }); } catch (e) {}
  window.yghStockApply = apply;
  // Re-rendered fragments (side cart, marquee clones) bring the tokens back: rescan cheaply.
  setInterval(apply, 1500);
  // The side cart loads its markup on open (?section_id=mini-cart): fill its tokens before that paint, not 1.5 s later.
  try {
    var mc = document.getElementById('mini-cart');
    if (mc && window.MutationObserver) new MutationObserver(function () { apply(); }).observe(mc, { childList: true, subtree: true });
  } catch (e) {}
})();
